import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=31a369e8"
import script from "./ResumeCard.vue?vue&type=script&lang=js"
export * from "./ResumeCard.vue?vue&type=script&lang=js"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=31a369e8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports